var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('router-link',{attrs:{"to":{ name: 'page', params: { id: 1 } }}},[_c('img',{staticClass:"btn-start",attrs:{"src":_vm.titleImage,"alt":((_vm.page.title) + " - " + (_vm.page.text))},on:{"load":_vm.sendMessage}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }